import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BaseGetProvider } from "@tendercuts/http";
import { StoreConfig } from "@tendercuts/models";
import { LoginServices } from "@login";
import { EndPoint } from "@endpoint";

@Injectable({
  providedIn: "root",
})
export class StoreConfigService extends BaseGetProvider<StoreConfig> {
  constructor(
    public http: HttpClient,
    public endpointService: EndPoint,
    public loginService: LoginServices
  ) {
    super(http);
    this.delegate = this;
  }

  // override this
  preProcessResponse(response: any): any {
    return response.results;
  }

  get isCachable(): boolean {
    return false;
  }

  get isAuthenticatedEndpoint(): boolean {
    return false;
  }

  get authProtocol(): LoginServices {
    return this.loginService;
  }

  get model(): typeof StoreConfig {
    return StoreConfig;
  }

  get endpoint(): string {
    return this.endpointService.getStoreConfig();
  }

  getParams(storeId: number = 0): HttpParams {
    let params: HttpParams = new HttpParams();
    params = params.append("store_id", storeId.toString());

    return params;
  }
}
